module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "fda3de81-5ac8-4693-a4d7-a88794f085cd.8280f03c.jpg";